// extracted by mini-css-extract-plugin
export default {"modal":"Bio_modal__FcwM6","content":"Bio_content__z1Mef","top":"Bio_top__bOTXg","title":"Bio_title__HBQgy","closeButton":"Bio_closeButton__oHD0D","text":"Bio_text__ELMyS"};